import React, {useContext, useEffect, useState} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";
import {goVehisService} from "../../../utils/axios";

function VehicleInsuranceCheckbox({vehicleId, checked, onChange, onDataLoaded}) {
    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);
    const [insuranceData, setInsuranceData] = useState(null);

    useEffect(() => {
        goVehisService(`/vehicles/${vehicleId}/insurance`)
            .then(response => {
                setInsuranceData(response.data);
                if (onDataLoaded) onDataLoaded(response.data);
            })
            .catch(() => {
                const fallback = {companyInsurance: null, consumerInsurance: null};
                setInsuranceData(fallback);
                if (onDataLoaded) onDataLoaded(fallback);
            });
    }, [vehicleId]);

    if (insuranceData === null) return null;

    const amount = isCompany ? insuranceData.companyInsurance : insuranceData.consumerInsurance;
    const suffix = isCompany ? "netto" : "brutto";

    const priceText = amount != null
        ? Math.round(amount).toLocaleString('pl-PL') + " zł " + suffix
        : "indywidualna wycena";

    return (
        <div className="calc__form-item">
            <label className="search-checkbox-row calc__ins-row calc__ins-row--ocac">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="calc__insurance-ocac-input"
                />
                <span className="calc__ins-label">Ubezpieczenie OC/AC</span>
                <span className={"calc__ins-price" + (amount == null ? " calc__insurance-individual" : "")}>
                    {priceText}
                </span>
            </label>
        </div>
    );
}

export default VehicleInsuranceCheckbox;
